import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['toggle']

  closeOnEscape(event) {
    if (event.key === 'Escape') this.toggleTarget.checked = false
  }

  closeOnLinkClick(event) {
    if (event.target.closest('a')) this.toggleTarget.checked = false
  }
}
